import cntl from "cntl";
import PropTypes from "prop-types";
import { COLOR, SIZE } from "../constants";
import { useMemo, useState } from "react";
import SectionContent from "./SectionContent";

const propTypes = {
  content: PropTypes.object,
  description: PropTypes.string,
  size: PropTypes.oneOf([SIZE.sm, SIZE.md, SIZE.lg]),
  theme: PropTypes.oneOf([
    COLOR.dark,
    COLOR.gray,
    COLOR.light,
    COLOR.primary,
    COLOR.primary_light,
  ]),
};

function SectionHeader({ content, theme, description, size }) {
  const [bgColor, setBgColor] = useState("");
  const [descriptionColor, setDescriptionColor] = useState("");

  const wrapperCn = () => cntl`
    ${bgColor}
  `;

  const containerCn = () => cntl`
    mx-auto
    container
    px-3 md:px-8 py-16 md:py-24
  `;

  const contentAndDescriptionCn = () => cntl`
    flex
    flex-col
    gap-x-16
    ${description?.length ? cntl`justify-between md:flex-row` : cntl``}
  `;

  const descriptionCn = () => cntl`
    mt-4
    w-full
    text-xl
    md:w-1/3
    md:mt-12
    ${descriptionColor}
  `;

  useMemo(() => {
    switch (theme) {
      case COLOR.dark:
        setBgColor("bg-gray-light-10 dark:bg-gray-dark-10");
        setDescriptionColor("text-gray-light-10 dark:text-gray-dark-10");
        break;
      case COLOR.gray:
        setBgColor("bg-gray-light-2 dark:bg-gray-dark-2");
        setDescriptionColor("text-gray-light-11 dark:text-gray-dark-11");
        break;
      case COLOR.primary:
        setBgColor("bg-primary-light-10 dark:bg-primary-dark-10");
        setDescriptionColor("text-primary-light-10 dark:text-primary-dark-10");
        break;
      case COLOR.primary_light:
        setBgColor("bg-primary-light-2 dark:bg-primary-dark-2");
        setDescriptionColor("text-primary-light-11 dark:text-primary-dark-11");
        break;
      case COLOR.light:
        setBgColor("bg-white dark:bg-black");
        setDescriptionColor("text-gray-light-11 dark:text-gray-dark-11");
        break;
      default:
        setBgColor("bg-white dark:bg-black");
        setDescriptionColor("text-gray-light-11 dark:text-gray-dark-11");
        break;
    }
  }, [theme]);

  return (
    <div className={wrapperCn()}>
      <div className={containerCn()}>
        <div className={contentAndDescriptionCn()}>
          <SectionContent size={size} {...content} theme={theme} />
          {description?.length && (
            <div className={descriptionCn()}>{description}</div>
          )}
        </div>
      </div>
    </div>
  );
}

SectionHeader.prototype = propTypes;
export default SectionHeader;
